import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import Anchor from 'components/Anchor';
import UserAvatar from 'components/UserAvatar';

import { sendEvent } from 'lib/gtag';
import { toUserProfileLink } from 'lib/links';

const TopContributorsRankingUser = ({
  count,
  gaEventCategory,
  userId,
  userName,
  userPhoto,
  userUsername,
  userLevel,
  userPlacing,
}) => {
  const isLeadingContributor = userPlacing === 1;

  const onClick = () => {
    sendEvent({
      category: isLeadingContributor
        ? `${gaEventCategory}_star`
        : `${gaEventCategory}`,
      action: 'go_profile',
    });
  };

  return (
    <NextLink href={toUserProfileLink(userUsername)} prefetch={false} passHref>
      <Anchor
        className="h-fit"
        data-test-selector={`top-comments-contributor-ranking-${userPlacing}`}
        onClick={onClick}
      >
        <div
          className={twJoin(
            'mt-2 flex items-center overflow-hidden rounded-2',
            isLeadingContributor
              ? 'bg-communication-300 dark:bg-communication-400'
              : 'bg-neutral-high-300 dark:bg-neutral-low-100'
          )}
        >
          <Text
            className="px-2 text-neutral-low-300 dark:text-neutral-high-100"
            size="size3"
            bold
          >
            {`0${userPlacing}`}
          </Text>
          <div
            className={twJoin(
              'flex w-full items-center justify-start py-2 pl-2 pr-4',
              isLeadingContributor
                ? 'bg-communication-100 dark:bg-communication-500'
                : 'bg-neutral-high-200 dark:bg-neutral-low-200'
            )}
          >
            <div className="flex w-full items-center">
              <UserAvatar
                userId={userId}
                userLevel={userLevel}
                userName={userName}
                userPhoto={userPhoto}
                userUsername={userUsername}
              />
              <div className="ml-3">
                <Text
                  className="text-neutral-low-300 dark:text-neutral-high-100"
                  size="size2"
                  bold
                >
                  {userName}
                </Text>
                <Text size="size3">{count}</Text>
              </div>
            </div>
            {isLeadingContributor && (
              <Icon
                className="text-communication-300 dark:text-communication-400"
                name="star"
                size="size1"
              />
            )}
          </div>
        </div>
      </Anchor>
    </NextLink>
  );
};

TopContributorsRankingUser.propTypes = {
  count: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
  userPhoto: PropTypes.string.isRequired,
  userUsername: PropTypes.string.isRequired,
  userLevel: PropTypes.number.isRequired,
  userPlacing: PropTypes.number.isRequired,
};

export default TopContributorsRankingUser;
